'use strict';

module.exports = 0;



/*****************
 ** WEBPACK FOOTER
 ** ./~/shortid/lib/util/cluster-worker-id-browser.js
 ** module id = 4112
 ** module chunks = 0
 **/